<ng-container *transloco="let t">
  @if (!media?.isImage && imageWithFallback?.url !== null && ((image != null && media == null) || !media?.isVideo)) {
    <section class="image-container hidden-print">
      <img
        class="media-image"
        [src]="imageWithFallback?.url + (imageAdjustments ?? '')"
        [alt]="imageWithFallback?.description"
        [width]="imageWithFallback.width"
        [height]="imageWithFallback.height" />
    </section>
  }
  @if (media) {
    @if (media.isAudio) {
      <kui-audio-player
        class="hidden-print"
        [analyticsPageName]="analyticsPageName"
        [showControls]="showAudioControls"
        [isOnBackground]="isOnBackground"
        [url]="media.url"
        [title]="media.title"
        [detailCardData]="detailCardData"></kui-audio-player>
    } @else if (media.isVideo) {
      <kui-video-player
        class="hidden-print"
        [altText]="media.placeholderImage?.description"
        [analyticsPageName]="analyticsPageName"
        [primary]="primaryColorVideoPlay"
        [url]="media.url"
        [title]="media.title"
        [imageUrl]="imageWithFallback?.url + (imageAdjustments ?? '')"
        [detailCardData]="detailCardData"></kui-video-player>
    } @else if (media.isImage) {
      <section class="image-container hidden-print">
        <img
          class="media-image"
          [src]="media.asImage?.url"
          [alt]="media.asImage?.description"
          [width]="media.asImage.width"
          [height]="media.asImage.height" />
      </section>
    }
    @if (renderTranscript && media.rawTranscript) {
      <kui-accordion-group
        class="hidden-print"
        [key]="transcriptKey"
        [initialStateOpen]="transcriptInitiallyOpen"
        [toggleText]="showTranscript ? t('ui.Hide Transcript') : t('ui.Show Transcript')"
        (didChange)="transcriptAccordionChange($event)">
        <div acc-open class="audio-container">
          <span class="transcript-accordion-toggle">
            @if (showTranscript) {
              {{ t('ui.Hide Transcript') }}
            } @else {
              {{ t('ui.Show Transcript') }}
            }
          </span>
        </div>
        <div acc-collapsible class="body-transcript">
          <kui-rich-text [richText]="media.rawTranscript" [translate]="false"></kui-rich-text>
        </div>
      </kui-accordion-group>
    }
  }
</ng-container>
